import { Badge as MuiBadge, Stack, styled, SxProps } from '@mui/material'
import { MouseEvent, ReactNode } from 'react'
import { AddIcon } from '@weblite/icons'

export function StoryAvatarBadge({
  invisible,
  children,
  onClick,
  sx,
  dataTestId,
}: {
  invisible?: boolean
  children: ReactNode
  onClick?: (e: MouseEvent<HTMLDivElement>) => void
  sx?: SxProps
  dataTestId?: string
}) {
  return (
    <Badge
      overlap="circular"
      onClick={onClick}
      invisible={invisible}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{ cursor: onClick ? 'pointer' : undefined, ...sx }}
      data-test-id={dataTestId}
      badgeContent={
        <BadgeContainer>
          <AddIcon
            sx={{ color: 'neutral000', width: '16px', height: '16px' }}
          />
        </BadgeContainer>
      }
    >
      {children}
    </Badge>
  )
}

const Badge = styled(MuiBadge)`
  &.MuiBadge-root {
    width: fit-content;
    height: fit-content;
    padding: 0;
  }
`
const BadgeContainer = styled(Stack)`
  width: 22px;
  height: 22px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.palette.neutral000};
  background: ${({ theme }) => theme.palette.secondary.main};
`
